import { Tabpanel } from '@pelckmans/business-components/components/tabs';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import WordlistHierarchyList from './WordlistHierarchyList';
import WordlistViewModeContext, { WordlistViewMode } from './_contexts/WordlistViewModeContext';
import useWordlistWords from './_hooks/useWordlistWords';
import Button from '@pelckmans/elementis/components/button';

export default function WordlistListTab() {
  const { t } = useTranslation();
  const words = useWordlistWords();

  const { setViewMode } = useContext(WordlistViewModeContext);

  return (
    <Tabpanel tabId="list" className="wordlist__tab">
      <WordlistHierarchyList />
      {(words || []).length > 0 && (
        <div className="wordlist__actions">
          <Button prominence="neutral" onClick={() => setViewMode(WordlistViewMode.FOCUS)} size="md">
            {t('MODULES.MATERIAL.COMPONENTS.WORD_LISTS.LEARN_WORDS')}
          </Button>
        </div>
      )}
    </Tabpanel>
  );
}
